import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { linksUrl } from "../constants/enum";

function ErrorCard() {
  const { compCode } = useSelector((state) => state.company)
  const { isAuthenticated ,user} = useSelector((state) => state.auth)
  
  return (
    <div className="bg-yellow-200 px-6 py-4 my-4 rounded-md text-lg flex gap-4  items-center mx-auto max-w-lg">
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        className="text-yellow-600"
      />
      <span className="text-yellow-800">{ isAuthenticated && user && compCode && compCode.length <= 0 ? (<div className="text-sm">Select Company  ! <Link to={linksUrl.companies} style={{color:"#eb8b0e"}} className="text-sm text-Rose-700" >Click Here</Link> </div> ):
      (<div className="text-sm">Something went wrong ! click to <Link to={linksUrl.login} style={{color:"#eb8b0e"}} className="text-sm text-Rose-700  underline" > Reconnect</Link> </div> )} </span>
    </div>
  )
}
export default ErrorCard